<template>
  <div class="about-us">
    <div class="about-us-banner">
      <img :src="loadUrl.banner_bg" />
      <div>关于我们</div>
    </div>
    <div class="about-us-content">
      <div class="introduce">
        <div>公司介绍</div>
        <div>
          <div>混空（Mixed Space）是一家专注元宇宙数实融合场景建设的公司，深耕XR+AI技术突破，以技术平台为发展引擎，为各行业提供元宇宙数实融合的解决方案。</div>
          <div>混空自研核心底层技术VPS（Visual Positioning System），通过AI视觉算法与多源数据融合，实现厘米级空间定位。具备抗遮挡、低延迟、多设备兼容等特性，适用于AR导航和城市级大空间定位场景。同时，客户可通过公司自研的元宇宙内容创作与分发平台——混空 Studio（智能体），一站式完成空间数字化建模和元宇宙互动营销场景创作，并通过XR眼镜、手机等实现跨端数实融合体验。</div>
          <div>以行业应用为导向，公司在文娱、商业、工业、教育等领域已有诸多成功案例，切实帮助全行业实现数实升级、提质增效。公司获得国家双软企业认定和国家科技型中小企业认定，已申请近60项软件著作和知识产权，并凭借数实融合技术多次斩获国内投资价值类奖项，成为元宇宙、数智化领域的头部公司。</div>
        </div>
      </div>
      <div class="company-profile">
        <img :src="loadUrl.company_profile" />
      </div>
      <!-- <div class="honor">
          <div class="title">荣誉及资质</div>
        </div> -->
      <div class="ryzz honor">
        <div class="title">荣誉资质</div>
        <div class="prev" @click="prevEvent"></div>
        <div class="next" @click="nextEvent"></div>
        <div class="ryzz-list">
          <div class="honors-box" :style="{ left: -(activeIndex - 1) * 232 + 'rem' }">
            <div v-for="(item, index) in showHonors" :key="index" :class="index == activeIndex ? 'active' : ''">
              <img :src="item.url" />
              <div>
                <div v-for="(e, i) in item.illustrate" :key="i">{{ e }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="xwzx">
        <div class="title-font-style title">公司动态</div>
        <div class="xwzx-box">
          <div class="news-content">
            <div v-for="(e, i) in newsList" :key="i" @click="toOtherPath(e.relatedHtmlId, e.title)"
              :class="activeNewsIndex == i ? 'active' : ''">
              <div>{{ e.title }}</div>
              <div>{{ e.times }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, watch, onMounted, onUnmounted, reactive } from 'vue'
import { selectCommonElement, addConsult } from '@/api'
import router from '@/router';
import { asynchronousRetrieval } from '@/utils'
const loadUrl: any = ref({})

const showIndexs: any = ref([3, 0, 1, 2, 3])
let timer: any = null;
let timer2: any = null;
let timer3: any = null;
let clicks: any = false;
const newsList: any = ref([])
const honors = [
  {
    url: require('@/assets/images/about_us/ryzz1.png'),
    illustrate: ['2023上海最具投资潜力']
  },
  {
    url: require('@/assets/images/about_us/ryzz2.png'),
    illustrate: ['“创客中国”元宇宙（人工智能）']
  },
  {
    url: require('@/assets/images/about_us/ryzz3.png'),
    illustrate: ['2023数智创新优胜奖']
  },
  {
    url: require('@/assets/images/about_us/ryzz6.png'),
    illustrate: ['2024年度典型案例']
  },
  {
    url: require('@/assets/images/about_us/ryzz7.png'),
    illustrate: ['上海市创新创业大赛 优胜奖']
  },
]

const active_r_i = ref(1)
const showHonors: any = ref([])
const activeIndex = ref(2)
const activeNewsIndex = ref(0)


const toOtherPath = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
}

const prevEvent = () => {
  if (clicks) return;
  clicks = true;
  (document.querySelector('.honors-box') as any).style.transition = 'all .5s';
  (document.querySelectorAll('.honors-box>div') as any).forEach((ele: any) => {
    ele.style.transition = 'all .5s'
  });
  if (active_r_i.value != 0) {
    active_r_i.value -= 1;
  } else {
    active_r_i.value = honors.length - 1
  }
  activeIndex.value -= 1;
}

const nextEvent = () => {
  if (clicks) return;
  clicks = true;
  (document.querySelector('.honors-box') as any).style.transition = 'all .5s';
  (document.querySelectorAll('.honors-box>div') as any).forEach((ele: any) => {
    ele.style.transition = 'all .5s'
  });
  if (active_r_i.value != honors.length - 1) {
    active_r_i.value += 1;
  } else {
    active_r_i.value = 0
  }
  activeIndex.value += 1;
}
onMounted(async () => {
  showHonors.value = showIndexs.value.map((k: number) => honors[k]);
  clearInterval(timer)
  timer = setInterval(() => {
    nextEvent()
  }, 3000)

  selectCommonElement({ columnId: 5, appId: 2 }).then((res: any) => {
    newsList.value = res.slice(0, 4).map((e: any) => {
      const date = new Date(e.newsTimestamp || e.createTime)
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      e.times = `${y}-${m}-${d}`
      return e;
    })
  })

  clearInterval(timer3)
  timer3 = setInterval(() => {
    activeNewsIndex.value += 1;
    if (activeNewsIndex.value > 3) {
      activeNewsIndex.value = 0;
    }
  }, 3000)

  const particle_moment_mp4: any = await asynchronousRetrieval('webimg/images/home/particles-moment.mp4');
  const banner_bg: any = await asynchronousRetrieval('webimg/images/about_us/banner-bg.png');
  const company_profile: any = await asynchronousRetrieval('webimg/images/about_us/company-profile.png');
  loadUrl.value = { particle_moment_mp4, banner_bg, company_profile }
})

onUnmounted(() => {
  clearInterval(timer)
  clearInterval(timer2)
  clearInterval(timer3)
})

watch(active_r_i, (newState) => {
  clearInterval(timer)
  showIndexs.value = showIndexs.value.map((v: number, i: number) => {
    if (i < 2) {
      if ((newState - (2 - i)) >= 0) {
        return newState - (2 - i)
      } else {
        return (honors.length + newState) - (2 - i)
      }
    }
    if (i == 2) return newState
    if (i > 2) {
      if ((newState < honors.length - 2) || (newState + (i - 2) < honors.length)) {
        return newState + (i - 2)
      } else {
        return newState + (i - 2) - honors.length
      }
    }
  });
  clearTimeout(timer2)
  timer2 = setTimeout(() => {
    (document.querySelector('.honors-box') as any).style.transition = 'none';
    (document.querySelectorAll('.honors-box>div') as any).forEach((ele: any) => {
      ele.style.transition = 'none'
    });
    showHonors.value = showIndexs.value.map((k: number) => honors[k]);
    activeIndex.value = 2
    clicks = false
    clearInterval(timer)
    timer = setInterval(() => {
      nextEvent()
    }, 3000)
  }, 500)
})
</script>
<style scoped lang="less">
.about-us-banner {
  position: relative;
  height: 208rem;
  line-height: 208rem;
  text-align: center;
  font-weight: 600;
  font-size: 40rem;
  color: #FFFFFF;

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
  }

  &>div {
    position: relative;
    z-index: 1;
  }
}

.about-us-content {
  background: #F6FAFF;
  padding-top: 48rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: left;

  .introduce {
    padding: 0 75rem;
    box-sizing: border-box;

    &>div:first-child {
      font-size: 40rem;
      color: #000000;
      line-height: 56rem;
      margin-bottom: 18rem;
    }

    &>div:last-child {
      font-weight: 400;
      font-size: 20rem;
      color: #5D5D5D;
      line-height: 30rem;

      &>div {
        margin-bottom: 38rem;
      }
    }
  }

  .company-profile {
    margin-top: 20rem;

    img {
      width: 600rem;
      height: 216rem;
    }
  }

  .title {
    font-size: 40rem;
    color: #000000;
    text-align: left;
    padding-left: 76rem;
  }

  .honor {
    margin-top: 66rem;
  }
}

.ryzz {
  position: relative;
  width: 750rem;
  display: inline-block;

  .title {
    padding-left: 76rem;
    font-size: 40rem;
    color: #000000;
    line-height: 56rem;
  }

  .ryzz-list {
    position: relative;
    width: 100%;
    height: 400rem;
    margin-top: 48rem;
    overflow: hidden;
    z-index: 0;

    .honors-box {
      position: absolute;
      top: 0;
      width: 1214rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &>div {
        position: relative;
        width: 232rem;
        height: 270rem;
        border-radius: 6rem;
        padding-top: 10rem;
        box-sizing: border-box;
        text-align: center;
        border: 1px solid #D8D8D8;

        img {
          width: 168rem;
          height: auto;
        }

        &>div {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 68rem;
          padding: 15rem 0;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          box-sizing: border-box;
          background-color: #2E76FF;
          font-weight: bold;
          font-size: 14rem;
          color: #FFFFFF;
          line-height: 28rem;
          border-radius: 0 0 8rem 8rem;
        }
      }

      .active {
        transform: scale(1.14);
        margin: 24.5rem;
        box-shadow: 0px 10rem 12rem 0px rgba(46, 118, 255, 0.2), 0px 0px 4rem 0px rgba(46, 118, 255, 0.2);
      }
    }
  }

  .prev,
  .next {
    position: absolute;
    top: 246rem;
    width: 50rem;
    height: 50rem;
    padding: 0;
    cursor: pointer;
    z-index: 2;
  }

  .prev {
    background: url(~@/assets/images/home/left.png);
    background-size: 100% 100%;
    left: 36rem;
  }

  .next {
    background: url(~@/assets/images/home/left.png);
    background-size: 100% 100%;
    right: 36rem;
    transform: rotate(180deg);
  }
}

.xwzx {
  width: 750rem;

  .more-box {
    font-weight: 400;
    font-size: 18rem;
    color: #D81417;
    font-family: PingFangSC-Medium;
    margin-top: 20rem;

    &>div {
      display: inline-block;
      cursor: pointer;
    }

    span {
      vertical-align: middle;
    }

    img {
      width: 6rem;
      height: 11rem;
      vertical-align: middle;
      margin-left: 6rem;
    }

    padding-bottom: 73rem;
  }

  .xwzx-box {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 48rem;
    box-sizing: border-box;
    font-size: 0;
    padding: 0 58rem 0 74rem;

    .news-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;

      &>div {
        text-align: left;
        font-family: PingFangSC-Medium;
        font-weight: bold;
        color: #414141;
        margin-bottom: 48rem;

        &>div:first-child {
          font-weight: 500;
          font-size: 28rem;
          line-height: 40rem;
        }

        &>div:last-child {
          font-weight: 400;
          font-size: 20rem;
          margin-top: 8rem;
        }
      }
    }
  }
}

.bg-video {
  position: relative;
  // width: 1920rem;
  height: 620rem;

  video {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }

  .contact-us {
    width: 1266rem;
    height: 396rem;
    background: rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.1);
    background-clip: padding-box;
    backdrop-filter: blur(6rem);
    position: absolute;
    left: 50%;
    top: 120rem;
    margin-left: -633rem;
    border-radius: 12rem;
    padding: 62rem 72rem;
    box-sizing: border-box;

    .title {
      font-weight: 500;
      font-size: 32rem;
      color: #D3D3D3;
    }

    .form-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 59rem;

      &>div {
        position: relative;
        width: 267rem;
        height: 40rem;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 8rem;
      }
    }

    .submit-btn {
      width: 152rem;
      height: 56rem;
      line-height: 56rem;
      background: #0675FF;
      border-radius: 8rem;
      text-align: center;
      font-weight: 500;
      font-size: 24rem;
      color: #FFFFFF;
      margin-top: 80rem;
      margin-left: 470rem;
      cursor: pointer;
    }
  }

  .contact-service {
    position: relative;
    width: 1266rem;
    height: 396rem;
    position: absolute;
    left: 50%;
    top: 120rem;
    margin-left: -633rem;
    border-radius: 12rem;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 12rem;
    border: 1px solid #464646;
    backdrop-filter: blur(12rem);
    padding: 40rem 87rem;
    box-sizing: border-box;

    .title {
      font-weight: 500;
      font-size: 32rem;
      color: #fff;
    }

    .title-tips {
      font-weight: 400;
      font-size: 14rem;
      color: #FFFFFF;
      margin-top: 12rem;
      margin-bottom: 50rem;
    }

    .service-list {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &>div:first-child {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        font-weight: 400;
        font-size: 14rem;
        color: #FFFFFF;

        img {
          width: 123rem;
          height: 123rem;
          margin-bottom: 6rem;
        }
      }

      &>div {
        width: 356rem;
        height: 187rem;
        background: #151515;
        border-radius: 12rem;
        border: 1px solid #4A4A4A;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 40rem 0;
        box-sizing: border-box;

        .fontBold {
          font-weight: bold;
          font-size: 20rem;
          color: #FFFFFF;
        }

        .fontNormal {
          font-weight: 500;
          font-size: 14rem;
          color: #7C7C7C;
        }

      }
    }

    .closed {
      width: 30rem;
      height: 30rem;
      background: url(~@/assets/images/home/close.png);
      background-size: 100% 100%;
      position: absolute;
      right: 30rem;
      top: 25rem;
      cursor: pointer;
    }
  }
}
</style>